import React from "react";
import AuthBaseComponent from "../bases/AuthBase/AuthBase";
import MarketingNavbar from "../../marketing/MarketingNavbar/MarketingNavbar";
import MarketingFooter from "../../marketing/MarketingFooter/MarketingFooter";

export default function AuthPage() {
  return (
    <div className="d-flex flex-column min-vh-100 bg-body text-body">
      <MarketingNavbar />
      <AuthBaseComponent />
      <MarketingFooter />
    </div>
  );
}
